const React = require("react");
const withState = require("../../../../../utils/withState");
const {mobile$} = require("../../../../../emitters/mobile");
const {loadingReconnect$} = require("../../../../../api/_auth");
const {account$} = require("../../../../../emitters/account");

const Logo = require("../Logo");
const Navigation = require("../Navigation");
const UserMenu = require("../UserMenu");

module.exports = withState(() => {
  return (state, props) => {
    return (
      <div className="abs s ov ovxA bgF ff$3 c0">
        <div className="rlv h wmin100%+265@m">
          <div className="w300 w265@m w388@d3 abs svl ovx ovyA pr20">
            <div className="bgF6F6F6 hmin pb30 pl30 pl15@m pl100@d3">
              <Logo />
              <Navigation/>
            </div>
          </div>
          <div className="abs sl300 sl265@m sl388@d3 svr ovxA ovyS">
            <div className="hmin ph30 ph15@m ph50@d2 pr100@d3 w ov">
              <div className="hmin rlv">
                <UserMenu />
                <div
                  className="pt60 pb80 ff$3 c0"
                >{props.children}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };
}, {
  mobile: mobile$,
  loadingReconnect: loadingReconnect$,
  account: account$,
});
